import {
  DisplayRuleDefinition,
  FieldMetadataDefinition,
  FieldMetadataMap,
  FieldStateDefinition,
  FieldStateMap,
} from '@diagentech/exprworks-rule-engine';

import { LabelItem } from '@/App/apiWrapper';
import { Calendar, DataState, MapEntries } from '@/App/types';
import { Data } from '@/App/types/ruleEngineTypes';
import { PersonInput } from '@/components/dialogs/PersonDialogFragment';
import { HoroscopeState } from '@/features/horoscope';
import { PersonState } from '@/features/person';
import { UserState } from '@/features/user';
import { ChangePasswordState } from '@/features/user/changePassword';
import { DeleteProfileState } from '@/features/user/deleteProfile';
import { ForgotPasswordState } from '@/features/user/forgotPassword';
import { LoginState } from '@/features/user/login';
import { RegisterState } from '@/features/user/register';

export interface DisplayRuleState {
  defaultState: MapEntries<FieldStateDefinition> | null;
  currentState?: FieldStateMap | null;
  metadata: MapEntries<FieldMetadataDefinition> | null;
  currentMetadata?: FieldMetadataMap | null;
  displayRuleDefs: DisplayRuleDefinition[] | null;
  dataState: DataState;
}

export type DisplayRuleStateMap = {
  [key in string]: DisplayRuleState;
};

export const initialState: DisplayRuleStateMap = {};

export const displayRuleInitialState: DisplayRuleState = {
  defaultState: null,
  metadata: null,
  displayRuleDefs: null,
  dataState: DataState.INITIAL,
};

export type DataType =
  | HoroscopeState
  | LoginState
  | RegisterState
  | ForgotPasswordState
  | PersonState
  | PersonInput
  | DeleteProfileState
  | UserState
  | ChangePasswordState
  | LabelItem
  | Calendar
  | Data;
